//
import values from 'lodash/values';
import { type Reducer, combineReducers } from 'redux';
import type { Action } from '../actions';
import type { UserAnswerMapT } from './answers';
import answers, { defaultState as defaultAnswersState } from './answers';
import modals from './modals';
import questions, { defaultState as defaultQuestionsState } from './questions';
import topQuestionIds, { defaultState as defaultTopQuestionIdsState } from './topQuestionIds';
import type { ValidationType, QuestionTypeType } from './constants';
export type TopQuestionIdsType = Array<string>;
export type TagsType = Array<string>;
export type OperatorMapT = {
  not_equals: 'not_equals';
  equals: 'equals';
  includes: 'includes';
  not_includes: 'not_includes';
  metadata_equals: 'metadata_equals';
  metadata_not_equals: 'metadata_not_equals';
  metadata_includes: 'metadata_includes';
  metadata_not_includes: 'metadata_not_includes';
};

// this is snake_cased due to the server data model
export const operatorMap = {
  not_equals: 'not_equals',
  equals: 'equals',
  includes: 'includes',
  not_includes: 'not_includes',
  metadata_equals: 'metadata_equals',
  metadata_not_equals: 'metadata_not_equals',
  metadata_includes: 'metadata_includes',
  metadata_not_includes: 'metadata_not_includes'
};
export enum InputSubType {
  shouldDisablePaste = 'disable_paste',
  hasDynamicSizing = 'dynamic_size',
}
export enum FieldType {
  dynamicField = 'dynamic_field',
}
export enum NumberSubType {
  rating_slider = 'rating_slider',
}
export enum SliderLabels {
  labels = 'labels',
}
export enum SelectSubType {
  checkbox = 'checkbox',
  radio = 'radio',
  drag_and_rank = 'drag_and_rank',
}
export const operators = values(operatorMap);
export type OperatorValues = OperatorMapT[keyof OperatorMapT];
export type OperatorKeys = keyof OperatorMapT;
export type ConditionType = {
  id: string;
  answer: string;
  operator?: string;
};
export type ConditionsType = Array<Array<ConditionType>>;
export type FollowUpType = {
  conditions: ConditionsType;
  questionIds: string[];
};
export type AnswerT = string;
export type AnswerItemT = {
  answer: string;
  note: 'none' | 'required' | 'optional';
  noteDesc?: string;
  noteValidator?: string;
  virtual?: boolean;
  metadata?: any;
};
export type AnswerItemsT = Array<AnswerItemT>;
export type ModalT = {
  type: string;
  meta: any;
};
export type Validation = {
  type: ValidationType;
  value: string;
};
export type QuestionType = {
  id: string;
  question: string;
  type: QuestionTypeType;
  tags: TagsType;
  answers: AnswerItemsT;
  limit: number;
  followUps: Array<{
    conditions: ConditionsType;
    questionId?: string;
    questionIds?: string[];
  }>;
  isRequired?: boolean;
  validations?: Array<Validation | undefined | null>;
  showValidationErrors?: boolean;
};
export type QuestionsType = {
  [x: string]: QuestionType;
};
export type QnAStateType = {
  questions: QuestionsType;
  topQuestionIds: TopQuestionIdsType;
  answers: UserAnswerMapT;
  modals?: Array<ModalT>;
};
export type ExtraAnswerOptionRendererT = {
  question: QuestionType;
  updateQuestion: Function;
};
export type ExtraAnswerRendererT = {
  question: QuestionType;
  showOptions: boolean;
  editMode: boolean;
  updateQuestion: Function;
};
export type MetadataRendererT = {
  question: QuestionType;
  answerItem: AnswerItemT;
  updateQuestion: Function;
  idx: number;
};
export type ExitEditModeHandlerT = {
  question: QuestionType;
};
export const exampleState: QnAStateType = {
  topQuestionIds: defaultTopQuestionIdsState,
  answers: defaultAnswersState,
  questions: defaultQuestionsState
};
const combinedReducer: Reducer<any, Action> = combineReducers({
  topQuestionIds,
  questions,
  answers,
  modals
});
export default combinedReducer;
export * from './constants';